"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearPlaylist = exports.setSafeSwitchZone = exports.updatePlaylistPlayStartTime = exports.updatePlaylist = exports.rotatePlaylistItem = exports.setPlaylistMetadata = exports.nextLocalRotationId = void 0;
var initialState = {
    lastLocalRotationId: 0,
    safeSwitchZone: true,
};
function nextLocalRotationId() {
    return {
        type: nextLocalRotationId.type,
    };
}
exports.nextLocalRotationId = nextLocalRotationId;
nextLocalRotationId.type = "playlist/nextLocalRotationId";
function setPlaylistMetadata(metadata) {
    return {
        type: setPlaylistMetadata.type,
        payload: { metadata: metadata },
    };
}
exports.setPlaylistMetadata = setPlaylistMetadata;
setPlaylistMetadata.type = "playlist/setMetadata";
function rotatePlaylistItem() {
    return {
        type: rotatePlaylistItem.type,
    };
}
exports.rotatePlaylistItem = rotatePlaylistItem;
rotatePlaylistItem.type = "playlist/rotate";
function updatePlaylist(items) {
    return {
        type: updatePlaylist.type,
        payload: { items: items },
    };
}
exports.updatePlaylist = updatePlaylist;
updatePlaylist.type = "playlist/update";
function updatePlaylistPlayStartTime(timestamp) {
    return {
        type: updatePlaylistPlayStartTime.type,
        payload: { timestamp: timestamp },
    };
}
exports.updatePlaylistPlayStartTime = updatePlaylistPlayStartTime;
updatePlaylistPlayStartTime.type = "playlist/updatePlayStartTime";
function setSafeSwitchZone(state) {
    return {
        type: setSafeSwitchZone.type,
        payload: {
            state: state,
        },
    };
}
exports.setSafeSwitchZone = setSafeSwitchZone;
setSafeSwitchZone.type = "playlist/setSafeSwitchZone";
function clearPlaylist() {
    return {
        type: clearPlaylist.type,
    };
}
exports.clearPlaylist = clearPlaylist;
clearPlaylist.type = "playlist/clearPlaylist";
function playlistReducer(state, action) {
    var _a, _b;
    if (state === void 0) { state = initialState; }
    var metadata = (_a = state.metadata) !== null && _a !== void 0 ? _a : {};
    var items = (_b = state.items) !== null && _b !== void 0 ? _b : [];
    switch (action.type) {
        case nextLocalRotationId.type:
            return __assign(__assign({}, state), { lastLocalRotationId: state.lastLocalRotationId - 1 });
        case setSafeSwitchZone.type:
            return __assign(__assign({}, state), { safeSwitchZone: action.payload.state });
        case setPlaylistMetadata.type:
            return __assign(__assign({}, state), { metadata: __assign(__assign({}, metadata), action.payload.metadata), items: items });
        case updatePlaylist.type:
            return __assign(__assign({}, state), { metadata: __assign(__assign({}, metadata), { lastUpdate: Date.now() }), items: action.payload.items });
        case rotatePlaylistItem.type:
            return __assign(__assign({}, state), { metadata: metadata, items: items.slice(1) });
        case updatePlaylistPlayStartTime.type:
            return __assign(__assign({}, state), { metadata: metadata, items: items.map(function (item, index) {
                    return index === 0 ? __assign(__assign({}, item), { playStartedAt: action.payload.timestamp }) : item;
                }) });
        case clearPlaylist.type:
            return __assign(__assign({}, state), { safeSwitchZone: true, lastLocalRotationId: 0, items: [] });
        default:
            return state;
    }
}
exports.default = playlistReducer;
//# sourceMappingURL=playlist.js.map